import { forwardRef } from "react";
import classNames from "classnames";

export const CRating = forwardRef(
  ({ value = 1, onChange, disabled = false }, ref) => {
    //#region Event
    const onStarClick = (newValue) => () => {
      onChange?.(newValue);
    };
    //#endregion

    //#region Render
    return (
      <div className="grid grid-cols-5 w-[135px]">
        {Array(10)
          .fill("")
          .map((e, index) => (
            <i
              key={`star-${index + 1}`}
              onClick={!disabled ? onStarClick(index + 1) : undefined}
              className={classNames(
                value >= index + 1 ? "fa-solid" : "fa-regular",
                disabled
                  ? "cursor-default text-[#56b3a8a4]"
                  : "cursor-pointer text-[#5CB0A6]",
                "text-[24px] fa-star transition-all duration-100"
              )}
            ></i>
          ))}
      </div>
    );
    //#endregion
  }
);
